import React from "react";
//import PMGatiShaktiTag from "./../../assets/pm-gatishakti.svg";
import PMGatiShaktiTag from "./../../../../assets/PM GATISHAKTI TAG-Agenda (1).svg";

export const PmGatiShakti = ({ className, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={PMGatiShaktiTag} />
    </div>
  ) : null;
};
